module.exports = __webpack_public_path__ + "static/media/DesignSmartBtn.be17cd75.svg";